import type { duplicateTask } from "@/db/operations"

type DuplicateResult = Awaited<ReturnType<typeof duplicateTask>>

/** What of a task's content a duplicate could not copy ("files" | "document" | "links"), across results. */
export function incompleteDuplicateParts(results: readonly DuplicateResult[]): string[] {
  const parts = new Set<string>()
  for (const r of results) {
    if (r.ok) for (const p of r.data.incomplete ?? []) parts.add(p)
  }
  return [...parts]
}

/** English names of the parts, for a toast that has no i18n (the keyboard shortcut's). */
export const INCOMPLETE_PART_LABELS: Record<string, string> = {
  files: "attached files",
  document: "document",
  links: "image links",
}
